/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SmsEnrollmentResponse } from '../models/SmsEnrollmentResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SmsEnrollmentService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Retrieve SMS enrollment status for a specific phone number.
     * Check the enrollment status of a phone number for SMS messaging.
     * @returns SmsEnrollmentResponse OK
     * @throws ApiError
     */
    public getSmsEnrollmentStatus({
        phoneNumber,
    }: {
        /**
         * Phone number to check the enrollment status for.
         */
        phoneNumber: string,
    }): CancelablePromise<SmsEnrollmentResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sms/enrollment-status',
            query: {
                'phone_number': phoneNumber,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Update or create SMS enrollment status for a specific phone number.
     * Updates the enrollment status for SMS messaging or creates a new one if it does not exist.
     * @returns SmsEnrollmentResponse OK
     * @throws ApiError
     */
    public updateSmsEnrollmentStatus({
        requestBody,
    }: {
        /**
         * Request payload for updating SMS enrollment status
         */
        requestBody: {
            phone_number: string;
        },
    }): CancelablePromise<SmsEnrollmentResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/sms/enrollment-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Batch update or create SMS enrollment statuses for multiple phone numbers.
     * Batch update SMS enrollment statuses or create new ones for multiple phone numbers.
     * @returns any OK
     * @throws ApiError
     */
    public batchUpdateSmsEnrollmentStatus({
        requestBody,
    }: {
        /**
         * Request payload for batch updating SMS enrollment statuses
         */
        requestBody: {
            phone_numbers: Array<string>;
            oid: string;
        },
    }): CancelablePromise<{
        /**
         * A map of phone numbers to their update statuses and errors, if any.
         */
        results?: Record<string, {
            /**
             * The result of processing the phone number.
             */
            status?: string;
            /**
             * Error message if the operation failed or was skipped.
             */
            error?: string | null;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/enrollment-status/batch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
